<template lang="pug">
  MapsPage(
    :zoom="zoom"
    :center="center"
    :markers="markers"
    :resource="resource")
</template>

<script>
  import MapsPage from '@/containers/MapsPage'

  export default {
    components: {
      MapsPage
    },
    data () {
      return {
        zoom: 13,
        center: [121.5273285, 31.25515044],
        resource: 'base/personalCenter',
        columns: {
          name: {
            label: '姓名'
          },
          message: {
            label: '信息'
          }
        },
        markers: {
          move: {
            icon: 'mark',
            group: ['group1', 'group2'],
            first: {
              icon: 'xxx',
              group: ['group1', 'group2']
            },
            last: {
              icon: 'xxx',
              group: ['group1', 'group2']
            }
          },
          reading: {
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// test.vue?15193e2e